export function parseManifest(raw) {
    if (typeof raw !== "object" || raw === null)
        return null;
    const o = raw;
    const id = o["id"];
    const name = o["name"];
    const players = o["players"];
    if (typeof id !== "string" || id.length === 0)
        return null;
    if (typeof name !== "string" || name.length === 0)
        return null;
    if (typeof players !== "number" || !Number.isFinite(players))
        return null;
    const type = o["type"] === "emulator" ? "emulator" : "html";
    const multiplayerRaw = o["multiplayer"];
    const multiplayer = typeof multiplayerRaw === "object" && multiplayerRaw !== null
        ? multiplayerRaw
        : {};
    const sync = multiplayer["sync"] === "none" ? "none" : "input";
    const controllerRaw = o["controller"];
    const controllerType = typeof controllerRaw === "object" &&
        controllerRaw !== null &&
        typeof controllerRaw["type"] === "string"
        ? controllerRaw["type"]
        : "generic";
    return {
        id,
        name,
        version: typeof o["version"] === "string" ? o["version"] : "0.0.0",
        type,
        players,
        controller: { type: controllerType },
        multiplayer: {
            supported: multiplayerRaw === undefined ? false : multiplayer["supported"] !== false,
            sync,
        },
        entry: typeof o["entry"] === "string" ? o["entry"] : undefined,
        tickRate: typeof o["tickRate"] === "number" ? o["tickRate"] : 20,
        inputDelayFrames: typeof o["inputDelayFrames"] === "number" ? o["inputDelayFrames"] : 2,
        stateHashInterval: typeof o["stateHashInterval"] === "number" ? o["stateHashInterval"] : 0,
        engine: typeof o["engine"] === "string" ? o["engine"] : undefined,
        core: typeof o["core"] === "string" ? o["core"] : undefined,
        description: typeof o["description"] === "string" ? o["description"] : undefined,
        icon: typeof o["icon"] === "string" ? o["icon"] : undefined,
    };
}
//# sourceMappingURL=manifest.js.map